import { PrimeNgDropdownEvent } from 'src/app/shared/primeng/events/dropdown-event';
import { FieldValueOperatorEnum } from 'src/app/shared/search-expression/field-value-operator.enum';
import { DatePeriodEnum } from '../../search-expression/date-period.enum';
import { SelectItem } from 'primeng/api';
import { SerialSearchExpression } from 'src/app/shared/search-expression/serial-search-expression.model';
import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { TranslationService, UtilService } from '../..';

@Component({
  selector: 'wl-date-search-expression',
  templateUrl: './date-search-expression.component.html',
  styleUrls: ['./date-search-expression.component.less'],
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DateSearchExpressionComponent implements OnInit, OnChanges {
  @Input() expression: SerialSearchExpression;
  fieldOperatorItems: SelectItem[] = [];
  datePeriodItems: SelectItem[] = [];
  datePeriodEnum = DatePeriodEnum;
  fieldValueOperatorEnum = FieldValueOperatorEnum;
  get selectedDate() {
    return this._selectedDate;
  }
  set selectedDate(value: Date) {
    this._selectedDate = value;
    this.expression.Value = value?.toISOString().slice(0, 10);
  }

  private _selectedDate: Date;

  constructor(private _translationService: TranslationService, private _utilService: UtilService) {}

  async ngOnInit(): Promise<void> {
    await this.setupFieldOperatorItems();
    await this.setupDatePeriodItems();
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.expression && this.expression) {
      if (this.expression.Value && !this._utilService.isNumeric(this.expression.Value)) {
        this.selectedDate = new Date(this.expression.Value);
      } else if (!this.expression.Value) {
        setTimeout(() => {
          this.selectedDate = null;
        });
      }
    }
  }

  operatorChanged(event: PrimeNgDropdownEvent<FieldValueOperatorEnum>) {
    if (event.value !== FieldValueOperatorEnum.InPeriod) {
      this.expression.Value = this.selectedDate?.toISOString().slice(0, 10);
    } else {
      this.expression.Value = null;
    }
  }

  private async setupFieldOperatorItems() {
    this.fieldOperatorItems = [
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.value-operator.equals'),
        value: FieldValueOperatorEnum.Equals,
      },
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.value-operator.not-equal'),
        value: FieldValueOperatorEnum.NotEqual,
      },
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.value-operator.greater-than'),
        value: FieldValueOperatorEnum.GreaterThan,
      },
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.value-operator.less-than'),
        value: FieldValueOperatorEnum.LessThan,
      },
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.value-operator.in-the-period'),
        value: FieldValueOperatorEnum.InPeriod,
      },
    ];
  }

  private async setupDatePeriodItems() {
    this.datePeriodItems = [
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.date-period-options.last-1-day'),
        value: DatePeriodEnum.Last1Day,
      },
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.date-period-options.last-7-days'),
        value: DatePeriodEnum.Last7Days,
      },
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.date-period-options.last-30-days'),
        value: DatePeriodEnum.Last30Days,
      },
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.date-period-options.month-to-date'),
        value: DatePeriodEnum.MonthToDate,
      },
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.date-period-options.year-to-date'),
        value: DatePeriodEnum.YearToDate,
      },
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.date-period-options.next-7-days'),
        value: DatePeriodEnum.Next7Days,
      },
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.date-period-options.next-30-days'),
        value: DatePeriodEnum.Next30Days,
      },
      {
        label: await this._translationService.getCapitalizeFirstCharacter('shared.widgets.expression.date-period-options.next-60-days'),
        value: DatePeriodEnum.Next60Days,
      },
    ];
  }
}
